import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import { ArrowRight } from 'lucide-react'
import Banner from '../../Components/Banner';
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection';


const featuresData = [
    {
        id: 1,
        title: "Product Development",
        description: "Work with Mobikode’s experienced team to bring your ideas to life. We design and build simple, high-performing software that grows with your business and feels easy to use.",
        image: "/assets/services/item6.png",
    },
    {
        id: 2,
        title: "Application Development",
        description: "When you partner with Mobikode, you work with UX/UI designers who truly understand your users. We focus on creating simple, intuitive, and engaging experiences for web and mobile so every interaction feels natural, easy, and meaningful, while helping your product connect better with the people who use it.",
        image: "/assets/services/item7.png",
    },
    {
        id: 3,
        title: "Application Modernization",
        description: "Give your legacy applications a fresh start with cloud migration support from Mobikode. We help you move toward open-source solutions and build an IT setup that feels more flexible, secure, and ready for what’s next so your business can run smoother and grow with confidence.",
        image: "/assets/services/item8.png",
    },
    {
        id: 4,
        title: "Quality Assurance Services",
        description: "We help businesses take the stress out of managing their technology with reliable, end-to-end quality assurance services. At Mobikode, we focus on getting the details right, reducing risks, improving performance, and ensuring everything runs smoothly. The result is better products, fewer surprises, and a stronger return on your investment.",
        image: "/assets/services/item9.png",
    }
];

const approachData = [
    {
        id: 1,
        title: "Innovation and Results",
        desc: "Mobikode helps businesses grow and adapt in their digital journey through the right blend of technology and strategy. We take time to understand your goals and challenges, creating practical, scalable solutions that deliver real value and long-term impact.",
        image: "/assets/service-detail/item4.png", // Replace with your actual image path
        link: "/services/innovation"
    },
    {
        id: 2,
        title: "Customized, Transformative Solutions",
        desc: "At Mobikode, we do more than deliver IT solutions we work as your trusted digital partner. We understand your goals, simplify operations, and create practical strategies that support steady growth and long-term success.",
        image: "/assets/service-detail/item3.png", // Replace with your actual image path
        link: "/services/solutions"
    }
];

function ProductEngineering() {
    return (
        <div>
            <Helmet>
    <title>
        Product Engineering Services | Digital Product Development | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides product engineering services for building scalable digital products, modern applications, and high-performing software with product development, application modernization, and quality assurance expertise."
    />

    <meta
        name="keywords"
        content="Product Engineering Services, Product Engineering Company, Product Development Services, Digital Product Development, Application Development Services, Web Application Development, Mobile Application Development, Application Modernization Services, Legacy Application Modernization, Software Product Development, Quality Assurance Services, Software QA Services, Scalable Product Development, Digital Engineering Services"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/product-engineering"
    />

    <meta
        property="og:title"
        content="Product Engineering Services | Digital Product Development | Mobikode"
    />

    <meta
        property="og:description"
        content="Turn ideas into scalable, high-performing digital products with Mobikode's product engineering services. We help businesses with product development, application development, modernization, and quality assurance."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/product-engineering"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/service-detail/bg5.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Product Engineering Services | Digital Product Development | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's product engineering solutions for product development, application development, application modernization, and quality assurance to build reliable digital products."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/service-detail/bg5.png"
    />
</Helmet>
            <AiHero title="Product Engineering" text="Future-proof Product Engineering Solutions." imgData="/assets/service-detail/bg5.png" />
            <br/>
            <br/>
            <br/>
            <WhyAIAutomation title="Explore Our Services" approachData={featuresData} />
            <section className="w-full bg-white pb-10 lg:pb-16 overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                    {/* Section Header */}
                    <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                            What We Stand For
                        </h2>
                    </div>

                    <div className="flex flex-col border border-[#01386A45]">
                        {approachData.map((item, index) => (
                            <div
                                key={item.id}
                                className={`group flex flex-col lg:flex-row w-full max-h-[350px] transition-all duration-300 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                                    }`}
                            >
                                <div className="w-full lg:w-1/2 h-[300px] lg:h-auto relative overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-[#01386A] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                                </div>

                                {/* Text Side 
                               Update: Changed 'justify-center' to 'justify-between'
                            */}
                                <div className="w-full lg:w-1/2 bg-white lg:p-[40px] p-8 flex flex-col justify-between border-l border-r border-[#01386A45] lg:border-none relative">

                                    {/* Top Content: Title */}
                                    <div>
                                        <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-4 leading-tight">
                                            {item.title}
                                        </h3>
                                    </div>

                                    {/* Bottom Content: Link or Description */}
                                    <div>
                                        {/* State 1: Read More (Visible by default) */}
                                        <div className="block group-hover:hidden transition-all duration-300 ease-in-out">
                                            <a
                                                href={item.link}
                                                className="inline-flex items-center text-[#01386A] font-semibold text-lg gap-2 hover:gap-3 transition-all duration-300"
                                            >
                                                Read More
                                                <ArrowRight size={20} />
                                            </a>
                                        </div>

                                        {/* State 2: Description (Visible on Hover) */}
                                        <div className="hidden group-hover:block animate-fadeIn transition-all duration-300 ease-in-out">
                                            <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-relaxed">
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>

                                    {/* === ANIMATED BOTTOM BORDERS === */}
                                    <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                                    <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Product Engineering Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">
                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Product Engineering Services
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                       At Mobikode, we help turn your ideas into scalable, high-performing products built to grow with your business and support your long-term success.
                        </p>

                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>

                </div>

            </section> */}
            <Banner title="Product Engineering Services" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default ProductEngineering
